import { render, staticRenderFns } from "./SubscribedProjectManagementSettings.vue?vue&type=template&id=04757438&"
import script from "./SubscribedProjectManagementSettings.vue?vue&type=script&lang=js&"
export * from "./SubscribedProjectManagementSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports